import React from "react";
import { Box, useColorMode } from "@chakra-ui/react";
import { useRouter } from "next/router";

const TopBackground = () => {
  const { colorMode } = useColorMode();
  const router = useRouter();
  return (
    <Box
      position={"absolute"}
      top={"-40px"}
      left={0}
      w={"full"}
      bgGradient={
        colorMode === "light"
          ? "linear(rgba(0, 178, 149, 0.1), white)"
          : "linear(rgba(0, 178, 149, 0.1), rgba(0, 178, 149, 0.2))"
      }
      zIndex={
        router.pathname.includes("/pricing") ||
        (router.pathname.includes("/contact") && -1)
      }
      h={"609px"}
    />
  );
};

export default TopBackground;
